import type { ApiClient } from './runtime/apiRuntime';
import { apiMutationOptions, BaseApiMutationOptions } from './apiMutationOptions';
import { apiQueryOptions, BaseApiQueryOptions } from './apiQueryOptions';

export const InterestApi = {
    getStatus: (webinarId: string, options?: BaseApiQueryOptions) =>
        apiQueryOptions(['interest', 'getStatus', webinarId], (api) => api.interest.getStatus(webinarId), options),
    showInterest: (options?: BaseApiMutationOptions<ApiClient['interest']['showInterest']>) => apiMutationOptions((api) => api.interest.showInterest, options),
    retractInterest: (options?: BaseApiMutationOptions<ApiClient['interest']['retractInterest']>) =>
        apiMutationOptions((api) => api.interest.retractInterest, options)
};
